// assets/js/components/revenue-calculator/steps/step-2.js
var ui = require("../ui");
var validate = require("../validate");
var data = require("../data");

function render(state) {
    var d = state.d;
    var html = ui.stepLabel(_t("Step 2 of 6")) + ui.h2(_t("How your business operates")) +
        ui.sub(_t("This helps us understand your current setup and growth potential."));

    html += ui.field({
        id: "rc-staff-count", label: _t("How many staff members work in your business?"), required: true,
        inner: ui.textInput({ id: "rc-staff-count", type: "number", value: d.staffCount, placeholder: _t("e.g. 3"), min: 1 })
    });
    html += ui.field({
        id: "rc-locations", label: _t("How many locations do you operate?"), required: true,
        inner: ui.textInput({ id: "rc-locations", type: "number", value: d.locations, placeholder: _t("e.g. 1"), min: 1 })
    });
    html += ui.field({
        id: "rc-has-booking-system", label: _t("Do you currently use a booking system?"), required: true,
        inner: ui.radioGroup({ id: "rc-has-booking-system", value: d.hasBookingSystem, options: data.options(["Yes", "No"]) })
    });
    if (d.hasBookingSystem === "Yes") {
        html += ui.field({
            id: "rc-booking-system", label: _t("Which booking system?"), required: true,
            inner: ui.select({ id: "rc-booking-system", value: d.bookingSystem, options: data.options(data.BOOKING_SYSTEMS) })
        });
        if (d.bookingSystem === "Other") {
            html += ui.field({
                id: "rc-booking-system-other", label: _t("Please specify"), required: true,
                inner: ui.textInput({ id: "rc-booking-system-other", value: d.bookingSystemOther, placeholder: _t("Name of your booking system") })
            });
        }
    }
    html += ui.primaryButton({ id: "rc-continue-btn", label: _t("Continue") });
    return ui.card(html);
}

function bind(container, state, actions) {
    var d = state.d;
    container.querySelector("#rc-staff-count").addEventListener("input", function (e) { actions.setField("staffCount", e.target.value); });
    container.querySelector("#rc-locations").addEventListener("input", function (e) { actions.setField("locations", e.target.value); });

    container.querySelectorAll('[data-radio-group="rc-has-booking-system"] [data-radio-value]').forEach(function (btn) {
        btn.addEventListener("click", function () {
            actions.setField("hasBookingSystem", btn.getAttribute("data-radio-value"));
            actions.setField("bookingSystem", "");
            actions.rerender();
        });
    });

    var sysEl = container.querySelector("#rc-booking-system");
    if (sysEl) sysEl.addEventListener("change", function (e) { actions.setField("bookingSystem", e.target.value); actions.rerender(); });
    var otherEl = container.querySelector("#rc-booking-system-other");
    if (otherEl) otherEl.addEventListener("input", function (e) { actions.setField("bookingSystemOther", e.target.value); });

    container.querySelector("#rc-continue-btn").addEventListener("click", function () {
        var numErr = validate.firstNumberError(d, [
            { key: "staffCount", id: "rc-staff-count", min: 1, max: 100000, integer: true },
            { key: "locations", id: "rc-locations", min: 1, max: 100000, integer: true }
        ]);
        if (numErr) {
            actions.showError(numErr.id, numErr.message);
            return;
        }
        if (!d.hasBookingSystem) {
            actions.showError("rc-has-booking-system", _t("Please complete all required fields."));
            return;
        }
        if (d.hasBookingSystem === "Yes" && !d.bookingSystem) {
            actions.showError("rc-booking-system", _t("Please select your booking system."));
            return;
        }
        state.step = 3;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
